import { useEffect } from "react"

import { useDispatch, useSelector } from "react-redux"

import { preferencesSuccess } from "../redux/user.actions"
import * as services from "../services"

export const useFetchUserPreferences = () => {
  const dispatch = useDispatch()
  const userId = useSelector((state) => state.auth.userInfo?.id)

  useEffect(() => {
    if (!userId) return

    const fetchPreferences = async () => {
      const response = await services.getUserPreferences()
      if (!response.ok) return

      dispatch(preferencesSuccess(response.data))
    }

    fetchPreferences()
  }, [userId])
}
